<vertical-slider [items]="this._newSideBannerList"></vertical-slider>
